// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3NhAs","vLegacy":"SelectSecondary_vLegacy__3KS0h","error":"SelectSecondary_error__2zQK5","disabled":"SelectSecondary_disabled__179KF"};